//
//
//
//
//
//
//
//
//
//
var GlobalRichText = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalRichText.vue');

export default {
  name: 'ImageLegend',
  components: {
    GlobalRichText
  },
  props: {
    legend: {
      type: Array,
      required: true
    },
    negativeText: {
      type: Boolean,
      default: false
    }
  }
};